import { History, ShieldCheck } from "lucide-react";
import { TrustSignals } from "@/components/skills/detail/TrustSignals";
import { VersionTimeline } from "@/components/skills/detail/VersionTimeline";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import type { SkillDetail } from "@/hooks/use-skill";

/**
 * Sticky-sidebar panel that toggles between trust Signals and version History
 * via a segmented control (replaces the two separate stacked panels).
 */
export function SidePanel({ skill }: { skill: SkillDetail }) {
  return (
    <div className="rounded-[12px] border border-border-1 bg-white p-5">
      <Tabs defaultValue="signals">
        <TabsList className="grid h-auto w-full grid-cols-2 gap-[3px] rounded-[9px] border border-border-1 bg-bg-3 p-[3px]">
          <TabsTrigger
            value="signals"
            className="gap-1.5 rounded-[7px] py-2 text-[12.5px] font-semibold text-fg-3 data-[state=active]:bg-white data-[state=active]:text-navy data-[state=active]:shadow-xs"
          >
            <ShieldCheck className="size-3.5" />
            Signals
          </TabsTrigger>
          <TabsTrigger
            value="history"
            className="gap-1.5 rounded-[7px] py-2 text-[12.5px] font-semibold text-fg-3 data-[state=active]:bg-white data-[state=active]:text-navy data-[state=active]:shadow-xs"
          >
            <History className="size-3.5" />
            History
          </TabsTrigger>
        </TabsList>
        <TabsContent value="signals" className="mt-4 animate-mk-fade">
          <TrustSignals skill={skill} />
        </TabsContent>
        <TabsContent value="history" className="mt-4 animate-mk-fade">
          <VersionTimeline history={skill.history} />
        </TabsContent>
      </Tabs>
    </div>
  );
}
